import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function OrderForm(props) {
    const { t } = useTranslation("translation");
    const orderFormDict = {
        true: t("OrderFormUsedL"),
        false: t("OrderFormNotUsedL")
    }
    const orderFormList = [
        { code: false, description: t("OrderFormNotUsedL")},
        { code: true, description: t("OrderFormUsedL")},
    ];

    return (
        <Autocomplete
            id="OrderForm_a"
            onChange={(_event, newValue) => {
                if (newValue === t("OrderFormNotUsedL")) {
                    props.HandleHasOrderPlaced(false);
                } else if (newValue === t("OrderFormUsedL")) {
                    props.HandleHasOrderPlaced(true);
                } else if (newValue === null) {
                    props.HandleHasOrderPlaced(null);
                }
            }}
            value={orderFormDict[props.hasOrderPlaced]}
            defaultValue=""
            options={orderFormList.map((option) => option.description)}
            renderInput={(params) => <TextField id="OrderForm_t" {...params} margin="normal" label={t("OrderFormStatus")} variant="outlined" />}
            size={props.size ?? "normal"}
        />
    );
}
